module.exports = __webpack_public_path__ + "pizza.jpg?bc1937208dc463a83980577fdee851cf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pizza.jpg
// module id = 46
// module chunks = 0